// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"520":"260fb190","698":"4a3ea9cd","885":"75fc9c18"}[chunkId] || chunkId) + "." + {"144":"ededbf323769cf9f","502":"0d53cfadbbfd5038","520":"91f14332a1cbd861","698":"04ddc162305da519","885":"f0e14dc7e250a3c0"}[chunkId] + ".js";
};